'use client'


import { usePathname } from 'next/navigation'
import { ArrowRight } from 'lucide-react'
import { formatImageURL, getMutedBackgroundColorStyles, getTextColorStyles, getVendorPrimaryColor } from '@/utils/util'
import { navigateUrl } from '@/utils/client-request'

export default function Blogs({ blogs, title, description, vendor }: { blogs: any[], title?: string, limit?: number, description?: string, vendor?: any }) {
  const pathname = usePathname() || ''
  const latest = blogs?.[0]
  if (!latest) return null
  const primary = getVendorPrimaryColor(vendor)
  const { className: tintClass, style: tintStyle } = getMutedBackgroundColorStyles(primary)
  const { className: accentClass, style: accentStyle } = getTextColorStyles(primary)
  return (
    <section className="bg-cream py-10 lg:py-12">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-4">
          <div style={tintStyle} className={`rounded-3xl ${tintClass} p-6 sm:p-10 lg:p-14 flex flex-col`}>
            <div className="text-[11px] tracking-[0.2em] uppercase font-semibold text-foreground/55">{title || 'Нийтлэл'}</div>
            <div
              className="mt-4 sm:mt-6 font-bold font-gilroy text-foreground leading-[0.96] tracking-[-0.025em]"
              style={{ fontSize: 'clamp(28px,4vw,56px)' }}
            >
              Сонголтоо<br /><em style={accentStyle} className={`not-italic ${accentClass}`}>илүү ухаалаг</em><br />хий.
            </div>
            <p className="mt-4 sm:mt-6 text-[14px] sm:text-[15px] text-foreground/75 max-w-md leading-relaxed">
              {description || 'Манай дэлгүүрийн шинэ мэдээлэл болон мэргэжлийн зөвлөмжүүдийг уншина уу.'}
            </p>
            <div className="mt-auto pt-6 sm:pt-8 flex flex-wrap gap-3">
              <a href={navigateUrl('/blog', pathname)} className="px-6 h-12 inline-flex items-center rounded-full bg-foreground text-white text-[15px] font-semibold hover:bg-foreground/90 transition-colors">
                Бүх нийтлэл
              </a>
            </div>
          </div>
          <a href={navigateUrl(`/blog/${latest.id}`, pathname)} className="relative rounded-3xl overflow-hidden aspect-4/3 sm:aspect-16/9 lg:aspect-auto lg:min-h-105 bg-foreground group">
            {latest.thumbnail && (
              <img
                src={formatImageURL(latest.thumbnail)}
                alt={latest.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
              />
            )}
            <div className="absolute inset-0 bg-linear-to-t from-black/55 via-black/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 lg:p-10 text-white">
              <span className="inline-flex items-center px-3 h-7 rounded-full bg-[#F1EEE7] text-foreground text-[11px] font-bold mb-3 sm:mb-4">Нийтлэл</span>
              <div
                className="font-bold font-gilroy leading-[0.98] tracking-[-0.02em] max-w-md"
                style={{ fontSize: 'clamp(20px,2.6vw,38px)' }}
              >
                {latest.title}
              </div>
              <div className="mt-3 sm:mt-5 inline-flex items-center gap-1.5 text-[14px] font-semibold">
                Үргэлжлүүлэн унших <ArrowRight className="size-3.5 group-hover:translate-x-0.5 transition-transform" />
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  )
}
